var constants = {
  default: {
    froala: {
      key: `${process.env.BASE_FROALA_KEY}`,
      imageUploadURL: `${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/download_files/upload`,
      imageUploadMethod: 'PUT',
      toolbarInline: true,
      charCounterCount: false,
      toolbarButtons: [
        'fullscreen',
        'bold',
        'italic',
        'underline',
        'strikeThrough',
        'subscript',
        'superscript',
        '|',
        'fontFamily',
        'fontSize',
        'color',
        'inlineStyle',
        'paragraphStyle',
        '|',
        'paragraphFormat',
        'align',
        'formatOL',
        'formatUL',
        'outdent',
        'indent',
        'quote',
        '-',
        'insertLink',
        'insertImage',
        'insertVideo',
        'insertFile',
        'insertTable',
        '|',
        'emoticons',
        'specialCharacters',
        'insertHR',
        'selectAll',
        'clearFormatting',
        '|',
        'help',
        'html',
        '|',
        'undo',
        'redo'
      ]
    }
  }
}

export default constants



// WEBPACK FOOTER //
// ./src/assets/constants.js